export default function Domain() {
    let domain = location.hostname;
    if (location.hostname !== "localhost") {
        const parts = location.hostname.split(".");
        domain = parts.slice(1).join(".");
    }

    return domain;
}
